import {Button} from '@/components/ui/button/Button'
import {DialogDisclosure, DialogProvider} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {Text} from '@/components/ui/text/Text'
import {AgendaEventDetailsDialog} from '@/features/agenda/components/agenda-event-details-dialog/AgendaEventDetailsDialog'
import {useGetEvent} from '@/features/agenda/queries/useGetEvent'
import {EventExtended} from '@/features/agenda/types'
import {StyledProjectWarningMissingBanner} from '@/features/projects/components/project-warning-missing-banner/style'
import {Trans, useTranslation} from '@/translations/i18n'

export const ProjectWarningMissingEvaluationEventCompleted = ({eventId}: {eventId: string}) => {
    const {t} = useTranslation()
    const {data: event, isPending} = useGetEvent({
        eventId,
        responseType: 'extended'
    })

    return (
        <StyledProjectWarningMissingBanner align="center">
            <Flexbox gap={1} align="center">
                <AlertCircleIcon />
                <Text palette="neutral" shade="950" size="textSm">
                    <Trans
                        i18nKey="projects:missing_event_content_completed"
                        components={{b: <b />}}
                        values={{
                            event: t('agenda:access_initial_project_evaluation')
                        }}
                    />
                </Text>
            </Flexbox>
            {isPending ? (
                <Button size="sm" variant="tertiary" disabled>
                    <Spinner />
                </Button>
            ) : (
                event && <ProjectWarningCompleteEventButtonDialog event={event} />
            )}
        </StyledProjectWarningMissingBanner>
    )
}

const ProjectWarningCompleteEventButtonDialog = ({event}: {event: EventExtended}) => {
    const {t} = useTranslation()
    return (
        <DialogProvider>
            <DialogDisclosure
                render={
                    <Button size="sm" variant="tertiary">
                        {t('projects:view_event')}
                    </Button>
                }
            />
            <AgendaEventDetailsDialog eventId={event.id} />
        </DialogProvider>
    )
}
